import { Button } from '@/components/button/button'
import { Card, CardContent } from '@/components/card/card'
import { DatePicker } from '@/components/date-picker/date-picker'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'
import { Form, FormField, FormItem, FormLabel } from '@/components/form/form'
import { Input } from '@/components/input/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/select/select'

import { cn } from '@/lib/utils'

import { useAddMoreInformationDialog } from './use-add-more-information-dialog'

export interface AddMoreInformationDialogProps {
  isDialogOpen: boolean
  closeDialog: VoidFunction
  handleChangeDialogOpen: (open: boolean) => void
}

export const AddMoreInformationDialog = ({
  isDialogOpen,
  closeDialog,
  handleChangeDialogOpen,
}: AddMoreInformationDialogProps) => {
  const { form, dataNvcCategories, isLoadingSaveButton, handleSubmitForm } = useAddMoreInformationDialog({
    closeDialog,
  })

  return (
    <Dialog open={isDialogOpen} onOpenChange={handleChangeDialogOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add more information</DialogTitle>
          <DialogDescription className="sr-only">Add more information to the NVC case</DialogDescription>
        </DialogHeader>
        <Card>
          <CardContent className={cn('p-6')}>
            <Form {...form}>
              <form className="space-y-4" onSubmit={form.handleSubmit(handleSubmitForm)}>
                {/* Location */}
                <FormField
                  control={form.control}
                  name="location"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Location</FormLabel>
                      <Input disabled value={field.value} />
                    </FormItem>
                  )}
                />

                {/* Category */}
                <FormField
                  control={form.control}
                  name="category"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Form Category</FormLabel>
                      <Select value={field.value} onValueChange={field.onChange}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select" />
                        </SelectTrigger>
                        <SelectContent>
                          {dataNvcCategories?.map(({ alias, code, description }) => (
                            <SelectItem key={code} value={code}>
                              {`${alias ? `${alias} -` : ''} ${description}`}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />

                {/* Date filed */}
                <FormField
                  control={form.control}
                  name="dateFiled"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Date filed</FormLabel>
                      <DatePicker placeholder="MM-DD-YYYY" value={field.value} onSelect={field.onChange} />
                    </FormItem>
                  )}
                />

                {/* Interview date */}
                <FormField
                  control={form.control}
                  name="interviewDate"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Interview date</FormLabel>
                      <DatePicker placeholder="MM-DD-YYYY" value={field.value} onSelect={field.onChange} />
                    </FormItem>
                  )}
                />

                <Button type="submit" loading={isLoadingSaveButton}>
                  Save
                </Button>
              </form>
            </Form>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  )
}
